export class Summary {
  constructor({
    to = "",
    toName = "",
    subject = "",
    emailBody = "",
    orderID = 0,
    anonymous = false,
    pdf = null
  } = {}) {
    this.to = to;
    this.subject = subject;
    this.emailBody = emailBody;
    this.orderID = orderID;
    this.anonymous = anonymous;
    this.toName = toName;
    this.pdf = pdf;
  }
}

export function CreateSummary(data) {
  return Object.freeze(new Summary(data));
}
